import enProgram from '../en/program';

const program = { ...enProgram, ...{
    'program.expiration.date.warning': '你的遊戲帳號期資格將在{date}過期。',
}};

export default program;
